import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import App from './App'
import { isNativePlatform } from './lib/platform'
import './index.css'

// Register PWA service worker only in browser — not inside Capacitor WebView.
// Inside APK the SW caches stale JS bundles and causes white screen on redeploy.
//
// Auto-update handling (fixes recurring iOS PWA breakage after a deploy): without
// this, the old SW keeps serving the old bundle — and once its outdated cache is
// cleaned, the app fails to load until a manual cache clear. We now check for a new
// SW on load and whenever the app regains focus (iOS PWAs stay open for days), and
// reload once when the new SW takes control so the fresh bundle is picked up.
if (!isNativePlatform() && 'serviceWorker' in navigator) {
  const hadController = Boolean(navigator.serviceWorker.controller)
  let reloading = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // A new SW activated → reload to load its fresh assets. Skip on the very first
    // install (no previous controller), which doesn't need a reload.
    if (reloading || !hadController) return
    reloading = true
    window.location.reload()
  })
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((reg) => {
      reg.update().catch(() => {})
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') reg.update().catch(() => {})
      })
    }).catch(() => {})
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
